import { useScrollReveal } from '@/hooks/useScrollReveal';

const examples = [
  {
    id: 'Запрос #1',
    tag: 'Реклама',
    quote: 'Ищу агентство для настройки рекламы в Яндекс Директ. Бюджет от 300 000 ₽.',
    status: [
      { label: 'Обнаружен системой', done: true },
      { label: 'ИИ начал диалог', done: true },
      { label: 'Назначен созвон', done: true },
    ],
  },
  {
    id: 'Запрос #2',
    tag: 'Разработка',
    quote: 'Нужен подрядчик на разработку корпоративного сайта.',
    status: [
      { label: 'Обнаружен системой', done: true },
      { label: 'Квалифицирован', done: true },
      { label: 'Передан менеджеру', done: true },
    ],
  },
  {
    id: 'Запрос #3',
    tag: 'CRM',
    quote: 'Посоветуйте интегратора Bitrix24.',
    status: [
      { label: 'Найден', done: true },
      { label: 'Проведена квалификация', done: true },
      { label: 'Назначена встреча', done: true },
    ],
  },
];

export default function TLExamples() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });

  return (
    <section id="cases" className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            Примеры
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Реальные примеры найденных запросов
          </h2>
          <p
            ref={descRef}
            className={`mt-4 text-[15px] text-foreground-500 reveal-fade-up ${descRevealed ? 'revealed' : ''}`}
          >
            Формулировки приведены в упрощённом виде. Личные данные клиентов скрыты по условиям соглашения.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {examples.map((ex) => (
            <article key={ex.id} className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden flex flex-col">
              <div className="bg-background-950 text-background-50 p-6 relative">
                <div className="flex items-center justify-between">
                  <span className="text-[12px] font-bold uppercase tracking-wider text-primary-400">{ex.id}</span>
                  <span className="text-[11px] font-medium px-2 py-1 rounded-md bg-background-50/10 text-background-50/80">{ex.tag}</span>
                </div>
                <p className="mt-5 font-display text-[18px] md:text-[19px] leading-snug text-background-50">
                  <span className="text-primary-500 text-2xl leading-none mr-1">"</span>
                  {ex.quote}
                  <span className="text-primary-500 text-2xl leading-none ml-1">"</span>
                </p>
              </div>
              <div className="p-6 bg-background-50">
                <div className="text-[12px] font-semibold uppercase tracking-wider text-foreground-400">Статус</div>
                <ul className="mt-3 space-y-2.5">
                  {ex.status.map((s) => (
                    <li key={s.label} className="flex items-center gap-2.5 text-[14px] text-foreground-800">
                      <span className="w-5 h-5 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
                        <i className="ri-check-line text-[12px]"></i>
                      </span>
                      {s.label}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}